import { ProgressPromise } from '@prezly/progress-promise';
import clamp from 'lodash.clamp';
import { toProgressPromise } from "./toProgressPromise.mjs";
var MIN_PROGRESS = 0;
var MAX_PROGRESS = 100;
export function awaitUploads(promises) {
  var result = {
    failedUploads: [],
    successfulUploads: []
  };

  if (promises.length === 0) {
    return new ProgressPromise(resolve => resolve(result));
  }

  var progressBuffer = new Array(promises.length).fill(MIN_PROGRESS);
  var resolvedCount = 0;
  return new ProgressPromise((resolve, _, reportProgress) => {
    function notifyProgress() {
      var sumProgress = progressBuffer.reduce((sum, subProgress) => sum + subProgress, 0);
      reportProgress(sumProgress / promises.length);
    }

    function resolveSubPromise(index) {
      progressBuffer[index] = MAX_PROGRESS;
      resolvedCount += 1;

      if (resolvedCount === promises.length) {
        resolve(result);
      } else {
        notifyProgress();
      }
    }

    promises.forEach((promise, index) => {
      toProgressPromise(promise).then(subResult => {
        result.successfulUploads.push(subResult);
        resolveSubPromise(index);
      }, subError => {
        result.failedUploads.push(subError);
        resolveSubPromise(index);
      }, subProgress => {
        progressBuffer[index] = clamp(subProgress, progressBuffer[index], MAX_PROGRESS);
        notifyProgress();
      });
    });
  });
}